// extracted by mini-css-extract-plugin
export default {"container":"BookCard_container__oTh5H","content":"BookCard_content__nbJzp","label":"BookCard_label__QAwFA","extraInfo":"BookCard_extraInfo__+HbUh"};